import React, { useState } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/styles';
import { Grid, Button, Typography } from '@material-ui/core';
import { DatePicker } from '@material-ui/pickers';
import FilterListIcon from '@material-ui/icons/FilterList';
import { Filter } from '../../components';
import { useSelector, useDispatch } from 'react-redux';
import { DashboardYearChange } from 'store/actions';
import { GetDashboard } from 'store/actions';

const Header = props => {
  const { className, ...rest } = props;
  const classes = useStyles();

  const dispatch = useDispatch();
  const maxDate = useSelector(({ dashboard }) => dashboard.maxDate);
  const minDate = useSelector(({ dashboard }) => dashboard.minDate);
  const startDate = useSelector(({ dashboard }) => dashboard.startDate);

  const [openFilter, setOpenFilter] = useState(false);
  const [openCalendar, setSpenCalendar] = useState(false);

  const handleFilterOpen = () => {
    setOpenFilter(true);
  };

  const handleFilterClose = () => {
    setOpenFilter(false);
    dispatch(GetDashboard());
  };

  const handleCalendarOpen = () => {
    setSpenCalendar(true);
  };

  const handleCalendarClose = () => {
    setSpenCalendar(false);
  };

  return (
    <div
      {...rest}
      className={clsx(classes.root, className)}
    >
      <Grid
        alignItems="flex-end"
        container
        justify="space-between"
        spacing={3}
      >
        <Grid item>
          <Typography
            gutterBottom
            variant="h2"
          >
                        Dashboard
          </Typography>
          <Typography variant="subtitle1">Here's what's happening</Typography>
        </Grid>
        <Grid item>
          <Button
            className={classes.filterButton}
            color="primary"
            onClick={handleFilterOpen}
            size="small"
            variant="outlined"
          >
            <FilterListIcon className={classes.filterIcon} /> Show filters
          </Button>
        </Grid>
        <Filter
          onClose={handleFilterClose}
          openCalendar={handleCalendarOpen}
          openFilter={openFilter}
        />
        <DatePicker
          autoOk
          label="Year"
          maxDate={maxDate}
          minDate={minDate}
          onChange={event => dispatch(DashboardYearChange(event))}
          onClose={handleCalendarClose}
          open={openCalendar}
          openTo="year"
          style={{ display: 'none' }}
          value={startDate}
          variant="dialog"
          views={['year']}
        />
      </Grid>
    </div>
  );
};

Header.propTypes = {
  className: PropTypes.string
};

Header.defaultProps = {};

export default Header;

const useStyles = makeStyles(theme => ({
  root: {},
  filterButton: {
    marginLeft: 'auto'
  },
  filterIcon: {
    marginRight: theme.spacing(1)
  },
  dates: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end'
  },
  startDateButton: {
    marginRight: theme.spacing(1)
  },
  endDateButton: {
    marginLeft: theme.spacing(1)
  },
  calendarTodayIcon: {
    marginRight: theme.spacing(1)
  }
}));
